import '../../../src/stylus/components/_grid.styl';
import Grid from './grid';
export default Grid('layout');
//# sourceMappingURL=VLayout.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/lib/components/VGrid/VLayout.js
// module id = null
// module chunks = 